import { useEffect, type FC } from 'react';
import { useNavigate } from 'react-router';
import type { SuperBundleServiceRequest } from 'src/apis/super-bundle-service/use-super-bundle-service-root';
import { Card } from 'src/components/data-display/card';
import { EmptyDataset } from 'src/components/data-display/empty-dataset';
import { PageHeader } from 'src/components/layout/page-header';
import { Link } from 'src/components/navigation/link';
import type { Successful } from 'src/hooks/use-axios';
import { useSaveReferrer } from 'src/hooks/use-referrer';
import { useTitle } from 'src/hooks/use-title';

type Props = {
  superBundleServiceRoot: Successful<SuperBundleServiceRequest>;
};

export const OfferOverview: FC<Props> = ({ superBundleServiceRoot }) => {
  const title = 'Super Bundle';
  useTitle(title);
  const savedReferrer = useSaveReferrer({ label: title });
  const navigate = useNavigate();
  const hasActiveOffer = !!superBundleServiceRoot.response.data._links.getOffer;

  // Redirect to the active offer if it exists
  useEffect(() => {
    if (hasActiveOffer) {
      const getOfferHref =
        superBundleServiceRoot.response.data._links.getOffer!.href;
      const offerId = getOfferHref.split('/').pop(); // Get the last part of the URL which is the offerId
      navigate(`/transport/super-bundle/offers/${offerId}`, { replace: true });
    }
    // oxlint-disable-next-line exhaustive-deps
  }, [hasActiveOffer]);

  return (
    <div className="grid items-center gap-md">
      <PageHeader
        title={title}
        actions={
          superBundleServiceRoot.response.data._links.createOffer ? (
            <Link
              data-testid="create-offer-button"
              mode="button-primary"
              {...savedReferrer.withReferrerLinkProps(
                '/transport/super-bundle/offers/create'
              )}
            >
              Create Offer
            </Link>
          ) : undefined
        }
      />

      <Card data-testid="no-active-offer-text">
        <EmptyDataset
          title="No Active Offer"
          description="There is no offer available."
        />
      </Card>
    </div>
  );
};
